import ModalBaseView from './ModalBase.View';
import type { ModalBaseProps } from './types';

const ModalBase: React.FC<ModalBaseProps> = props => {
  const { children } = props;
  return <ModalBaseView {...props}>{children}</ModalBaseView>;
};

export default ModalBase;
